import styled from 'styled-components'

// Centered intro header for the public share page: funeral home title,
// "in memory of" block, description, and expiration notice.
export const ShareHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 960px;
  padding: 24px 0 8px 0;
  text-align: center;
`

// White card that holds the product tabs and the active product's gallery.
export const GalleryCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 960px;
  background-color: #ffffff;
  border: 1px solid #e4e7f0;
  border-radius: 12px;
  padding: 24px 32px 32px 32px;
`

// Tab list shown when more than one product was shared.
export const ProductTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 16px;
`

export const ProductTab = styled.button<{ $active: boolean }>`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid ${({ $active }) => ($active ? '#1A6CAB' : '#DBDEE6')};
  background-color: ${({ $active }) => ($active ? '#F4F8FB' : '#ffffff')};
  color: ${({ $active }) => ($active ? '#1b1f3b' : '#4a4f68')};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    border-color: #1a6cab;
  }
`

// Matches GalleryCard's width so the banner stays aligned with the content
// card below it instead of spanning the full page.
export const NewerVersionBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  max-width: 960px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border: 1px solid #b8cfe3;
  border-radius: 12px;
  background-color: #eaf2f9;
`
